// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSCalculaPace = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/pace_01.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/pace_02.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/pace_03.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/pace_04.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/pace_05.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/pace_06.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/pace_07.jpeg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">TLS Calcula Pace</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tlsengenharia.calculapace"}
				apple_store={"https://apps.apple.com/us/app/tls-calcula-pace/id6762099888"}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										Transforme seus treinos e provas com o <strong>TLS Calcula Pace</strong>!<br />
										Ideal para corredores de todos os níveis, o aplicativo oferece ferramentas rápidas e precisas para converter pace, velocidade e tempo, além de auxiliar no planejamento de estratégias para provas e treinos.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Conversão de Pace:</strong> Converta facilmente entre pace, velocidade, tempo e distância.</li>
											<li><strong>Múltiplas Unidades:</strong> Suporte para quilômetros, milhas, metros, km/h, mph e m/s.</li>
											<li><strong>Planejamento de Provas:</strong> Defina uma distância e visualize as parciais teóricas para sua estratégia de corrida.</li>
											<li><strong>Histórico de Cálculos:</strong> Salve seus resultados e consulte-os sempre que necessário.</li>
											<li><strong>Interface Intuitiva:</strong> Simples, rápida e prática para o dia a dia dos corredores.</li>
										</ul>
										<br />
										Seja para melhorar sua performance, definir metas de treino ou planejar sua próxima prova, o TLS Calcula Pace é a ferramenta ideal para acompanhar sua evolução na corrida.
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										¡Mejora tus entrenamientos y competencias con <strong>TLS Calcula Pace</strong>!<br />
										Ideal para corredores de todos los niveles, la aplicación ofrece herramientas rápidas y precisas para convertir ritmo, velocidad y tiempo, además de ayudar en la planificación de estrategias para carreras y entrenamientos.
										<br />
										<br />
										<h3>Funciones:</h3><br />
										<ul>
											<li><strong>Conversión de Ritmo:</strong> Convierte fácilmente entre ritmo, velocidad, tiempo y distancia.</li>
											<li><strong>Múltiples Unidades:</strong> Soporte para kilómetros, millas, metros, km/h, mph y m/s.</li>
											<li><strong>Planificación de Carreras:</strong> Define una distancia y visualiza los parciales teóricos para tu estrategia.</li>
											<li><strong>Historial de Cálculos:</strong> Guarda tus resultados y accede a ellos cuando lo necesites.</li>
											<li><strong>Interfaz Intuitiva:</strong> Diseño simple, rápido y práctico para corredores.</li>
										</ul>
										<br />
										Ya sea para mejorar tu rendimiento, establecer objetivos de entrenamiento o planificar tu próxima carrera, TLS Calcula Pace es la herramienta ideal para acompañar tu evolución como corredor.
									</div>
								)
								:
								(
									<div className='term_just'>
										Improve your training and race performance with <strong>TLS Calcula Pace</strong>!<br />
										Designed for runners of all levels, the app provides fast and accurate tools to convert pace, speed, time, and distance while helping you plan race and training strategies.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>Pace Conversion:</strong> Easily convert between pace, speed, time, and distance.</li>
											<li><strong>Multiple Units:</strong> Support for kilometers, miles, meters, km/h, mph, and m/s.</li>
											<li><strong>Race Planning:</strong> Set a distance and view theoretical split times for your race strategy.</li>
											<li><strong>Calculation History:</strong> Save your calculations and access them anytime.</li>
											<li><strong>Intuitive Interface:</strong> Simple, fast, and practical for everyday training.</li>
										</ul>
										<br />
										Whether you're aiming to improve performance, set training goals, or prepare for your next race, TLS Calcula Pace is the perfect companion for your running journey.
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}

export default TLSCalculaPace